import React from 'react';

import { withRouter } from 'react-router-dom';
import { Drawer, DrawerContent } from '@progress/kendo-react-layout';

import { Header } from '../Header/Header';
import api from '../../api.js';
// import { ChartCategoryAxisNotesLabel } from '@progress/kendo-react-charts';



const items = [
    // { name: 'dashboard', icon: 'k-i-grid', selected: true , route: '/' },
    { name: 'Slot Message Monitor', icon: 'k-i-inbox', selected: true, route: '/slot-message-monitor' },
    { separator: true },
    { name: 'Flight Schedules', icon: 'k-i-calendar', route: '/flight-schedules' },
    { name: 'Flights', icon: 'flight-icon', route: '/flights' },
    // { name: 'integrationMonitor', icon: 'k-i-notification k-i-bell', selected: true , route: '/integration-monitor' },
    { name: 'Slot Message Submission', icon: 'k-i-change-manually', route: '/slot-message-submission' },
    { name: 'Data Providers', icon: 'k-i-tell-a-friend', route: '/dataProviders' },
];

class DrawerRouterContainer extends React.Component {
    state = {
        expanded: true,
        selectedId: items.findIndex(x => x.selected === true),
        isSmallerScreen: window.innerWidth < 768
    }

    componentDidMount() {
        api.reAuthenticate(false, 'keycloak').then((r) => {
            console.log(`reauthenticated`);
        }).catch(err => {
            console.log('redirecting to auth');
            this.props.history.push('/auth');
        });

        window.addEventListener('resize', this.resizeWindow)
        this.resizeWindow()
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resizeWindow)
    }

    resizeWindow = () => {
        this.setState({ isSmallerScreen: window.innerWidth < 768 })
    }

    handleClick = () => {
        this.setState((e) => ({ expanded: !e.expanded }));
    }


    handleSelect = (e) => {
        this.setState({ selectedId: e.itemIndex, expanded: false });
        this.props.history.push(e.itemTarget.props.route);
    }

    getSelectedItem = (pathName) => {
        let currentPath = items.find(item => item.route === pathName);
        console.log(pathName);
        if (currentPath && currentPath.name) {
            return currentPath.name;
        }
    }
    render() {
        let selected = this.getSelectedItem(this.props.location.pathname);

        return (
            <React.Fragment >
                <Header
                    onButtonClick={this.handleClick}
                    page={selected || 'Slot Message Monitor'}
                />
                <Drawer
                    expanded={this.state.expanded}
                    animation={{ duration: 100 }}
                    items={items.map((item) => ({
                        ...item,
                        text: item.name,
                        selected: item.name === selected
                    }))
                    }
                    position='start'
                    mode={this.state.isSmallerScreen ? 'overlay' : 'push'}
                    mini={this.state.isSmallerScreen ? false : true}


                    onOverlayClick={this.handleClick}
                    onSelect={this.handleSelect}
                >
                    <DrawerContent>
                        {this.props.children}
                    </DrawerContent>
                </Drawer>
            </React.Fragment >
        );
    }
};

export default withRouter(DrawerRouterContainer);